(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

	$( function() {
		$( "#alpha" ).tabs();
	} );


	$( function() {
	$( "#tabs" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-a" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-a li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-b" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-b li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-c" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-c li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-d" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-d li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-e" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-e li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-f" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-f li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-g" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-g li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-h" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-h li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-i" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-i li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-hi" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-hi li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-j" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-j li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-k" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-k li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-l" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-l li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-m" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-m li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-n" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-n li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-o" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-o li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-no" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-no li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-p" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-p li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-r" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-r li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-q" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-q li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-qr" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-qr li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-s" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-s li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-t" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-t li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-u" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-u li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-tu" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-tu li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-v" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-v li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-w" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-w li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-x" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-x li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-y" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-y li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );

	
	$( function() {
	$( "#tabs-z" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-z li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );


	$( function() {
	$( "#tabs-wz" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
	$( "#tabs-wz li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
	} );
  
  

  } catch(e) { console.error(e); }
})();
})();
